export default __webpack_public_path__ + "static/media/unity.ad58069d.svg";